<template>
  <main class="internal-home-page">
    <div class="internal-home-card">
      <div class="internal-home-badge">舊版工程師後台</div>
      <h1>內部管理功能</h1>
      <p>
        請從左側「基本資料」進入使用者、申請單、中獎名單或終端機授權管理。
        <template v-if="hasLog">亦可從 Log 選單查看系統記錄。</template>
      </p>
    </div>
  </main>
</template>

<script>
export default {
  name: "InternalHomePage",
  computed: {
    hasLog() {
      return this.$enum.roleType.isEngineer();
    },
  },
};
</script>

<style lang="scss" scoped>
.internal-home-page {
  padding: 24px;
}
.internal-home-card {
  padding: 28px;
  border-radius: 12px;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.16) 0 1px 5px;
  h1 {
    margin: 6px 0 12px;
    font-size: 26px;
  }
  p {
    margin: 0;
    color: #727272;
  }
}
.internal-home-badge {
  color: #4695c9;
  font-size: 14px;
}
</style>
